import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { EventListItem } from "src/app/models/event/event-list-item";
import { NotificationService } from "src/app/services/notification.service";
import { EventService } from "src/app/services/event.service";
import { NotificationItemType, SortProperty } from "../../../models/enums";
import { EventsResponse } from "../../../models/event/events-response";
import { KeyValuePair } from "../../../models/key-value-pair";
import { EventContainerService } from "../../../services/event-container.service";
import { AutoUnsubscribe } from "../../../shared/decorators";
import { getIconFromStatus } from "../../../shared/list-item.utils";

@Component({
  standalone: false,
  selector: "dua-event-list",
  templateUrl: "./event-list.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./event-list.component.scss"],
})
@AutoUnsubscribe()
export class EventListComponent implements OnInit, OnDestroy {
  @Input() eventsResponse!: EventsResponse;
  @Input() filterAnnouncement!: string;

  currentSortSubscription!: Subscription;
  currentSort = SortProperty.Alphabetically;
  sortOptions: KeyValuePair<string, SortProperty>[] = [
    new KeyValuePair("Alfabetisk ordning", SortProperty.Alphabetically),
    new KeyValuePair("Starttid", SortProperty.StartTime),
    new KeyValuePair("Senast uppdaterad", SortProperty.LastUpdate),
  ];

  constructor(
    private eventService: EventService,
    private eventContainerService: EventContainerService,
    private notificationService: NotificationService
  ) {
    this.currentSort = this.eventService.getCurrentSort();
  }

  ngOnInit() {
    this.currentSort = this.eventService.getCurrentSort();
  }

  ngOnDestroy() {}

  iconFromStatus(eventListItem: EventListItem): string {
    return getIconFromStatus(eventListItem?.notified, eventListItem?.status);
  }

  onSortChange(eventValue: SortProperty) {
    const sort = (eventValue as unknown) as string;
    this.eventService.setCurrentSort(parseInt(sort));
  }

  choseEvent(eventItem: EventListItem) {
    if (
      eventItem.notificationId &&
      eventItem.notificationType == NotificationItemType.Event
    ) {
      this.notificationService.setReadStatus([eventItem.notificationId]);
    }
    this.eventContainerService.populateEvent(eventItem.id);
  }
}
